import { QueryClient } from '@tanstack/react-query';

// Create a client with optimized defaults
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // Data is fresh for 1 minute
      gcTime: 300000, // Cache for 5 minutes (formerly cacheTime)
      // Permission denials and cancelled workspace requests cannot succeed on retry.
      retry: (failureCount, error) => error.name !== 'AbortError'
        && ![401, 403].includes((error as { statusCode?: number }).statusCode || 0)
        && failureCount < 1,
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnReconnect: true, // Refetch on reconnect
    },
  },
});

// Identity access can change in another session. Refresh on mount and focus so
// sender pickers do not keep using an identity whose access was removed.
for (const queryKey of ['mailboxes', 'sender-identities']) {
  queryClient.setQueryDefaults([queryKey], {
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
